import { TranslationsContext } from '@teliaee/telia-translate';
import { Button, Grid, GridColumn, Heading, Modal, ModalProvider, ModalTrigger, Notice, Separator, Text, TextField } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import config from '../../config';
import LanguageStore from '../../stores/LanguageStore';
import RoamingStore from '../../stores/RoamingStore';
import { Package } from '../RoamingInterfaces';
import SmsLink from './SmsLink';

interface PackageOrderingModalProps {
  roamingPackage: Package;
  roamingStore?: RoamingStore;
  languageStore?: LanguageStore;
}

@observer
class PackageOrderingModal extends React.Component<PackageOrderingModalProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;

  public render() {
    const translate = this.context.translate;
    const { roamingPackage, roamingStore } = this.props;
    const smsContent = this.props.roamingStore.getSmsMessageContent(roamingPackage);

    return (
      <ModalProvider>
        <ModalTrigger>
          <Button className="text__margin-double" block={true} text={translate('roaming.country.package.order')} id="order-package" />
        </ModalTrigger>
        <Modal>
          <Text className="text-center">
            <Heading element="h1" className="h4 text-normal">
              {translate(`roaming.country.package.modal.header.${roamingPackage.serviceShortName}`)}
            </Heading>
            <Heading element="h2" className="text__margin-none">
              {this.props.roamingStore.selectedCountry.name}
            </Heading>
            <p className="text-bold h3">
              {roamingStore.getPackagePrice(roamingPackage)} {translate('roaming.package.price.currency')}
            </p>
            <p
              dangerouslySetInnerHTML={{
                __html: translate('roaming.country.package.modal.send-sms')
              }}
            />
            <Grid align={['center-xs']}>
              <GridColumn width={['md-4']}>
                <TextField id="order-internet" label={translate('roaming.country.package.modal.sms-content')} value={smsContent} isReadOnly={true} />
                <SmsLink
                  number={translate('roaming.country.package.modal.send-sms-number')}
                  label={translate('roaming.country.package.modal.generate-sms')}
                  content={smsContent}
                />
              </GridColumn>
            </Grid>
            <Separator spacing="small" color="invisible" />
            <Grid align={['center-xs']}>
              <GridColumn width={['md-7']}>
                <Notice size="small">{translate('roaming.country.package.modal.notice-text')}</Notice>
                <Button
                  text={translate('roaming.country.package.modal.show-terms')}
                  link={true}
                  url={translate(`roaming.country.package.modal.terms.link.${roamingPackage.serviceShortName}`, { baseUrl: config.diil.webUrl })}
                  target="_blank"
                />
              </GridColumn>
            </Grid>
          </Text>
        </Modal>
      </ModalProvider>
    );
  }
}

export default inject('roamingStore', 'languageStore')(PackageOrderingModal);
